// folderDropdown.ts
import { Dropdown } from "./dropdown";
import { apiFetchFolders, deleteFolderToDb } from "../../api/folder";
import { Folder, state } from "../../app";
import { DetectorDropdown } from "./detector";
import { FolderSavePopup } from "../folderControls/FolderSavePopup";

export class FolderDropdown extends Dropdown<Folder> {
    private foldersCache: Folder[] = [];
    private menuDriver: HTMLElement;
    public detectorDropdown: DetectorDropdown;
    public folderSavePopup: FolderSavePopup;

    constructor() {
        super('folderDropdownBtn', 'folderDropdownMenu', 'folderDropdownLabel');
        this.menuDriver = document.createElement('div');
        this.menuDriver.id = `${'folderDropdownMenu'}Driver`;
        this.menu.appendChild(this.menuDriver);
        this.detectorDropdown = new DetectorDropdown('pointDropdownBtn', 'pointDropdownMenu', 'pointDropdownLabel')
        this.folderSavePopup = new FolderSavePopup();
    }

    /**
     * Логика при открытии выпадающего списка
     */
    protected async onOpen() {
        await this.loadMenu();
    }

    protected onClose() {
        // Можно добавить логику при закрытии
    }

    public async loadMenu() {
        this.menuDriver.innerHTML = '<div class="ui-dropdown-loading">Загрузка…</div>';
        const folders = await apiFetchFolders();
        this.foldersCache = folders || [];
        this.renderMenu();
    }

    public async onSelect(folder: Folder) {
        // Удаляеем все маркеры
        document.querySelectorAll('.maplibregl-marker').forEach(marker => marker.remove());
        this.label.textContent = folder.name.length > 18 ? folder.name.slice(0, 17) + '…' : folder.name;
        state.folder = folder;
        state.detectors?.forEach(d => {
            d.removeGraphics();
        })
        state.detectors = [];
        // Загружаем точки для выбранной папки
        await this.detectorDropdown.loadMenu();
        this.detectorDropdown.setNewSector();
    }


    private renderMenu() {
        this.menuDriver.innerHTML = '';
        this.setAddNewFolderElement();

        if (this.foldersCache.length > 0) {
            const divider = document.createElement('div');
            divider.className = 'ui-dropdown-divider';
            this.menuDriver.appendChild(divider);
        }

        // Добавляем папки в выпадающий список
        this.foldersCache.forEach(folder => this.createFolderLine(folder));
    }

    private setAddNewFolderElement() {
        const addItem = document.createElement('button');
        addItem.className = 'ui-dropdown-item';
        addItem.innerHTML = '➕ Создать папку';
        addItem.addEventListener('click', (e) => {
            e.stopPropagation();
            this.folderSavePopup.openModal();
        });
        this.menu.appendChild(addItem);
        this.menuDriver.appendChild(addItem);
    }


    /**
     * Создание линии папки (Название папки и кнопка удалить)
     * @param folder 
     */
    private createFolderLine(folder: Folder) {
        const div = document.createElement('div');
            div.classList.add('row');

            const item = document.createElement('button');
            item.className = 'ui-dropdown-item';
            if (state.folder?.id === folder.id) item.classList.add('active');
            item.innerHTML = `📁 ${folder.name}`;
            item.addEventListener('click', async (e) => {
                e.stopPropagation();
                state.folder = folder;
                await this.onSelect(folder);
                this.close();
            });

            const deleteBtn = document.createElement('button');
            deleteBtn.className = 'ui-dropdown-item';
            deleteBtn.style.width = '20%';
            deleteBtn.style.padding = '0';
            deleteBtn.style.justifyContent = 'center';
            deleteBtn.innerHTML = '❌';
            deleteBtn.addEventListener('click', async () => {
                await this.deleteFolder(folder.id);
            });

            div.appendChild(item);
            div.appendChild(deleteBtn);
            this.menuDriver.appendChild(div);
    }

    private deleteFolder = async (folderId: string) => {
        await deleteFolderToDb(folderId);
        await this.loadMenu();

        if(folderId == state.folder?.id){
            state.folder = null;
            state.detectors.forEach(d => d.removeGraphics());
            state.detectors = [];
            state.detector = null;
            this.btn.innerHTML = 'Выберите папку';
            this.detectorDropdown.clearMenu();
        }
    }
}